import { FilterSelects } from 'components/core';
import { Key } from 'react';
import { TFilterOptions } from 'utils/context/FilterContext/types';

import {
  Box,
  Flex,
  IconButton,
  reactIcons as Icons,
  Select,
  SelectItem,
} from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

interface Props {
  handleSelect: (value: string) => void;
  icons: { [key: string]: () => JSX.Element };
  onClear: (value: string) => void;
  options: Array<{
    config: TFilterOptions;
    startVariant?: string;
    value: string;
  }>;
  placeholder: string;
  value: string;
}

const styles = {
  root: {
    border: '1px solid $border-primary',
    borderRadius: '4px',
    position: 'relative',
    marginTop: '20px',
  },
  flex: {
    backgroundColor: 'white',
    left: '1.25rem',
    position: 'absolute',
    top: '-20px',
  },
};

function FilterSelectsGroup({
  handleSelect,
  icons = {},
  onClear,
  options,
  placeholder,
  value,
}: Props) {
  const { t } = useTranslation();
  const ListIcon = icons[value] || icons.default;
  const sel = options.find((option) => option.value === value);

  const handleChange = (value: Key) => {
    handleSelect(value as string);
  };

  return (
    <Box css={styles.root}>
      <Flex css={styles.flex}>
        <Select
          aria-label={placeholder}
          css={{ width: 225 }}
          onSelectionChange={handleChange}
          startIcon={!!ListIcon ? <ListIcon /> : undefined}
          placeholder={placeholder}
          selectedKey={value}
          children={options.map((option) => (
            <SelectItem key={option.value} aria-label={option.value}>
              {t(option.value)}
            </SelectItem>
          ))}
        />
        <IconButton
          data-testid="clear-button"
          css={{ border: '1px solid $palette-grey-500', borderLeft: 'none' }}
          children={<Icons.Close />}
          variant="tertiary"
          onPress={() => onClear(value)}
        />
      </Flex>
      <Box css={{ padding: '$x-large $large $medium' }}>
        {value && sel && (
          <FilterSelects
            title={value}
            options={sel.config}
            startVariant={sel.startVariant}
          />
        )}
      </Box>
    </Box>
  );
}

export default FilterSelectsGroup;
